import { ExclamationCircleOutlined } from '@ant-design/icons';
import { history } from '@umijs/max';
import { Modal, notification } from 'antd';
import Authentication from './Authentication';
import Policy from './Policy';

class FiscalizationNotification {
    private timeStorageKey: string = 'minutes';

    private durationInMinutues: number = 15;

    public failedInvoicesPageUrl: string = '/finance/failed/invoices';

    // data from the server
    public async getDataFromApi() {
        return await Policy.checkFailedInvoices();
    }

    // save time on local storage
    public saveOnLocalStorage() {
        const now = new Date();

        const expiresAt = now.getTime() + this.durationInMinutues * 60 * 1000; // Convert minutes to milliseconds

        localStorage.setItem(this.timeStorageKey, JSON.stringify(expiresAt));
    }

    private hasDataExpired() {
        const time = localStorage.getItem(this.timeStorageKey);

        // return true to fetch the invoices
        if (!time) return true;

        const milliseconds = Number(time);

        const now = new Date().getTime();

        return now > milliseconds;
    }

    public async init() {
        if (!this.hasDataExpired()) return;

        this.saveOnLocalStorage();

        const pageUrl = history.location.pathname;

        // we are at failed invoices, do not show modal
        if (pageUrl === this.failedInvoicesPageUrl) return;

        const response = await this.getDataFromApi();

        if (response.data === null) return;

        const invoiceCount = response.data?.failedInvoicesCount;

        if (invoiceCount === 0) return;

        Modal.confirm({
            title: (
                <div style={{ fontSize: 18 }}>
                    Error fiskalizimi: Ju keni {invoiceCount} fatur{invoiceCount === 1 ? 'e' : 'a'} te pa fiskalizuar{invoiceCount === 1 ? '' : 'a'}
                </div>
            ),
            width: 400,
            icon: <ExclamationCircleOutlined style={{ color: 'red', fontSize: 30 }} />,
            okText: 'Rregullo faturat',
            cancelText: 'Mbyll',
            onOk: () => {
                // page redirect
                history.push(this.failedInvoicesPageUrl);
            },
            cancelButtonProps: { style: Authentication.canIgnoreFailedInvoices() ? {} : { display: 'none' } },
            centered: true,
            style: {
                marginTop: '-200px',
            },
        });

        if (invoiceCount > 0 && location.pathname !== this.failedInvoicesPageUrl && !response.data?.isSaleAllowed) {
            history.push(this.failedInvoicesPageUrl);
            notification.error({
                message: <span style={{ fontWeight: 700 }}>Ju nuk mund te procedoni me shume ne sistem, pa rregulluar me pare faturat e deshtuara !!</span>,
            });

            // we delete the time, so if user tries to change the page we can redirect again
            localStorage.removeItem(this.timeStorageKey);
        }
    }
}

export default new FiscalizationNotification();
